import { withProps } from 'recompose';
import EmailInput from './EmailInput';
import ObjectInput from './ObjectInput';

export default withProps({
  schema: {
    email: EmailInput,
  },
})(ObjectInput);
